/* Anime-Pass — mobile nav drawer + accordion submenus
   Progressive enhancement: the markup is a plain <aside> that CSS keeps
   off-screen, so nothing is trapped if this script fails to load. */
(function () {
  'use strict';

  function init(root) {
    var toggle = root.querySelector('[data-ap-drawer-open]');
    var drawer = root.querySelector('[data-ap-drawer]');
    var overlay = root.querySelector('[data-ap-drawer-overlay]');
    var closeBtn = root.querySelector('[data-ap-drawer-close]');
    if (!toggle || !drawer || !overlay) return;

    if (root._apDrawerEsc) {
      document.removeEventListener('keydown', root._apDrawerEsc);
    }

    var lastFocused = null;

    function focusables() {
      return drawer.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.classList.add('open');
      overlay.classList.add('open');
      drawer.removeAttribute('inert');
      overlay.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      drawer.setAttribute('inert', '');
      overlay.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    // Keep focus inside the panel while it is open
    function trap(e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('open')) return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    toggle.addEventListener('click', open);
    overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('keydown', trap);
    root._apDrawerEsc = function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    };
    document.addEventListener('keydown', root._apDrawerEsc);

    // Close drawer on plain link click (not parent toggle buttons)
    drawer.querySelectorAll('.drawer-links > a').forEach(function (a) {
      a.addEventListener('click', close);
    });
    drawer.querySelectorAll('.drawer-sub a').forEach(function (a) {
      a.addEventListener('click', close);
    });

    // --- Accordion submenus ---
    drawer.querySelectorAll('.drawer-parent-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var sub = btn.nextElementSibling;
        if (!sub) return;

        // Close all other open accordions
        drawer.querySelectorAll('.drawer-parent-btn[aria-expanded="true"]').forEach(function (other) {
          if (other === btn) return;
          other.setAttribute('aria-expanded', 'false');
          var otherSub = other.nextElementSibling;
          if (otherSub) otherSub.hidden = true;
        });

        // Toggle this one
        btn.setAttribute('aria-expanded', String(!expanded));
        sub.hidden = expanded;
      });
    });

    drawer.setAttribute('inert', '');
  }

  function boot() {
    document.querySelectorAll('[data-ap-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the theme editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ap-header]');
    if (root) init(root);
  });
})();
